import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Bcx translate http loader (bcx-translate-http-loader.ts).
 * @todo Repeated in all Angular repositories. Move to a shared location
 *
 * @version
 * 4.26.0 OAUI-416 Add basic QR code order management route
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 */
export class BcxTranslateHttpLoader extends TranslateHttpLoader {
  defaultLocale: string;

  /**
   * Constructor
   * @since 4.26.0
   */
  constructor(
    defaultLocale: string,
    http: HttpClient,
    prefix?: string,
    suffix?: string,
  ) {
    super(http, prefix, suffix);
    this.defaultLocale = defaultLocale;
  }

  /**
   * Get and catch translation file errors
   * @since 4.26.0
   */
  getTranslation(lang: string): Observable<Object> {
    return super.getTranslation(lang).pipe(
      catchError(() => {
        console.log(
          `Warning: Locale language file '${lang}' not supported, using default '${this.defaultLocale}' instead`,
        );
        return super.getTranslation(this.defaultLocale);
      }),
    );
  }
}
